module.exports = __webpack_public_path__ + "static/media/home_bibeo.631d9666.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/images/home_bibeo.jpg
 ** module id = 261
 ** module chunks = 0
 **/